import React, { useState, useEffect } from 'react';
import Sidebar from '../SideBar/Sidebar';
import Title from '../Containers/Title';
import { Link } from "react-router-dom";
import 'react-datepicker/dist/react-datepicker.css';
import GraphClients from '../Containers/graphClients';
import db from '../../Db/db';

export default function Cas() {
    const json = localStorage.getItem("token")
    const userInfo = JSON.parse(json);
    const [submitData, setSubmitData] = useState([]);
    const [data, setData] = useState([]);
    const [clientsData, setClientsData] = useState([]);
    const [agence, setAgence] = useState([]);
    const [selectedAgence, setSelectedAgence] = useState("");
    const [commerciaux, setCommerciaux] = useState([]);
    const [selectedCommercial, setSelectedCommercial] = useState("tous");

    const handleSubmit = (submitFilterData) => {
        setSubmitData(submitFilterData);
    };

    useEffect(() => {
        async function fetchData() {
            const data1 = await db.caYear.toArray();
            setData(data1);
            const data2 = await db.clients.toArray();
            setClientsData(data2);
            const data3 = await db.agences.toArray();
            setAgence(data3);
            const data4 = await db.team.toArray();
            setCommerciaux(data4);

        }
        fetchData();
    }, []);


    const startDate = submitData.startDate ? new Date(submitData.startDate) : new Date(new Date().getFullYear(), 0, 1);
    const endDate = submitData.endDate ? new Date(submitData.endDate) : new Date();
    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();
    const startMonth = startDate.getMonth();
    const endMonth = endDate.getMonth();

    const months = ['Jan', 'Fev', 'Mar', 'Apr', 'Mai', 'Jui', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const filterYearsAndMonths = (client, startYear, endYear, startMonth, endMonth) => {
        const filteredAnnees = {};
    
        Object.keys(client.annees).forEach(year => {
            const intYear = parseInt(year);
    
            // Si l'année est complètement dans la période
            if (intYear > startYear && intYear < endYear) {
                filteredAnnees[year] = client.annees[year];
            }
            // Si l'année est la première année de la période
            else if (intYear === startYear) {
                const filteredMonths = {};
                Object.keys(client.annees[year]).forEach(month => {
                    const intMonth = parseInt(month) - 1;
                    if (intMonth >= startMonth) {
                        filteredMonths[month] = client.annees[year][month];
                    }
                });
                if (Object.keys(filteredMonths).length > 0) {
                    filteredAnnees[year] = filteredMonths;
                }
            }
            // Si l'année est la dernière année de la période
            else if (intYear === endYear) {
                const filteredMonths = {};
                Object.keys(client.annees[year]).forEach(month => {
                    const intMonth = parseInt(month) - 1;
                    if (intMonth <= endMonth) {
                        filteredMonths[month] = client.annees[year][month];
                    }
                });
                if (Object.keys(filteredMonths).length > 0) {
                    filteredAnnees[year] = filteredMonths;
                }
            }
        });
    
        return filteredAnnees;
    };

    // Fonction pour récupérer les mois entre startDate et endDate
    const getMonthsBetweenDates = (startDate, endDate) => {
        const start = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        const end = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
        const monthsInRange = [];

        while (start <= end) {
            
            const month = start.getMonth() + 1;
            const alreadyExists = monthsInRange.some(m => m.month === month);

            if (!alreadyExists) {
                monthsInRange.push({month });
            }
            start.setMonth(start.getMonth() + 1);
        }

        return monthsInRange;
    };


    const filteredMonths = getMonthsBetweenDates(startDate, endDate);
    let clients = [];
    
    if (submitData) {
        const { searchTerm, selectedOptions, commercial } = submitData;
    
        if (searchTerm !== undefined && searchTerm.length > 0) {
            if (searchTerm.includes('_PARENT')) {
                console.log(1)
                const allEnfants = clientsData.filter(cli => 
                    cli.codeClient === searchTerm.split(' / ')[0] && 
                    cli.codeAgence === searchTerm.split(' / ')[2]
                );
                allEnfants.forEach(client => {
                    if (client.enfants && client.enfants.length > 0) {
                        const filteredData = data.filter(item =>
                            client.enfants.some(enfant =>
                                item.codeClient === enfant.enfant && item.codeAgence === enfant.agence
                            )
                        );
                        clients.push(...filteredData);
                    }
                });
            } else {
                console.log(2)
                
                clients = data.filter(topi => 
                    topi.codeClient === searchTerm.split(' / ')[0] && 
                    topi.codeAgence === searchTerm.split(' / ')[2]
                );

            }
            clients = clients.map(client => {
                const filteredCurrentYears = filterYearsAndMonths(client, startYear, endYear, startMonth, endMonth);
                const filteredPreviousYears = filterYearsAndMonths(client, startYear, endYear - 1, startMonth, endMonth);
            
                return {
                    ...client,
                    annees: {
                        ...filteredPreviousYears,
                        ...filteredCurrentYears
                    }
                };
            }).filter(client => Object.keys(client.annees).length > 0);


        }else if (selectedAgence && selectedAgence !== 'toutes') {

            

            clients = data.filter(client => client.codeAgence === selectedAgence);
    
            clients = clients.map(client => {
                const filteredCurrentYears = filterYearsAndMonths(client, startYear, endYear, startMonth, endMonth);
                
                const filteredPreviousYears = filterYearsAndMonths(client, startYear, endYear - 1, startMonth, endMonth);
            
                return {
                    ...client,
                    annees: {
                        ...filteredPreviousYears,
                        ...filteredCurrentYears
                    }
                };
            }).filter(client => Object.keys(client.annees).length > 0);

           
    
        }
       
       
        else if (selectedCommercial && selectedCommercial !== "tous") {
            console.log(5)
            clients = data.filter(client => client.commercial === selectedCommercial);
        
            clients = clients.map(client => {
                const filteredCurrentYears = filterYearsAndMonths(client, startYear, endYear, startMonth, endMonth);
                const filteredPreviousYears = filterYearsAndMonths(client, startYear, endYear - 1, startMonth, endMonth);
                
                return {
                    ...client,
                    annees: {
                        ...filteredPreviousYears,
                        ...filteredCurrentYears
                        }
                };
            }).filter(client => Object.keys(client.annees).length > 0);
        
        }
        else if (selectedAgence === ''){
            clients = []
        }
        else {
            console.log(6)
            const commercialValue = userInfo.user.role.includes('Assistant')
                ? userInfo.user.role.split(" ")[1]
                : userInfo.user.role === 'Administrateur' || userInfo.user.role === 'Responsable'
                    ? null 
                    : userInfo.user.idUser;
    
            clients = data.filter(client => 
                userInfo.user.role === 'Administrateur' || userInfo.user.role === 'Responsable' || client.commercial === commercialValue
            );

            /**
             * TODO MODIFY
             */

            if (userInfo.user.idUser === 18) { // [ROLE] FIAURIE NICOLAS -> MENDIBOURE IONA
                clients = data.filter(client => 
                    client.commercial === 18 || client.commercial === 50
                );  
            }
    
            clients = clients.map(client => {
                const filteredCurrentYears = filterYearsAndMonths(client, startYear, endYear, startMonth, endMonth);
                const filteredPreviousYears = filterYearsAndMonths(client, startYear, endYear - 1, startMonth, endMonth);
            
                return {
                    ...client,
                    annees: {
                        ...filteredPreviousYears,
                        ...filteredCurrentYears
                    }
                };
            }).filter(client => Object.keys(client.annees).length > 0);
        }
    }

    const calculatePercentage = (current, previous) => {
        if (previous === 0) return current === 0 ? 0 : 100;
        return ((current - previous) / previous * 100).toFixed(2);
    };

    const totalCA_N = new Array(12).fill(0);
    const totalCA_N_1 = new Array(12).fill(0);
    let overallTotalCA_N = 0;
    let overallTotalCA_N_1 = 0;

    clients.forEach(client => {
        for (let intMonth = 0; intMonth < 12; intMonth++) { 
            if (client.annees[endYear] && client.annees[endYear][intMonth + 1]) {

                const caValue = parseFloat(client.annees[endYear][intMonth + 1].ca) || 0;
                totalCA_N[intMonth] += caValue;
                overallTotalCA_N += caValue;
            } else {
                totalCA_N[intMonth] += 0;
            }
    
            const previousYear = (endYear - 1).toString();
            
            if (client.annees[previousYear] && client.annees[previousYear][intMonth + 1]) {
                const caN1Value = parseFloat(client.annees[previousYear][intMonth + 1].ca) || 0;
                totalCA_N_1[intMonth] += caN1Value;
                overallTotalCA_N_1 += caN1Value;
            } else {
                totalCA_N_1[intMonth] += 0;
            }
        }
    });
    
    overallTotalCA_N = parseFloat(overallTotalCA_N) || 0;
    overallTotalCA_N_1 = parseFloat(overallTotalCA_N_1) || 0;


    /*let maxYear = null;
    let prevYear = null;

    clients.forEach(client => {
        Object.keys(client.annees).forEach(year => {
            const intYear = parseInt(year);
            if (!maxYear || intYear > maxYear) {
                maxYear = intYear;
            }
            if (!prevYear || intYear < prevYear) {
                prevYear = intYear;
            }
            if (maxYear == prevYear) {
                maxYear = intYear+1;
            }
            
        });
    });*/

    /*let allYears = new Set();

    clients.forEach(client => {
        Object.keys(client.annees).forEach(year => {
            allYears.add(parseInt(year))
        })
    })

    const sortedYears = Array.from(allYears).sort((a, b) => a - b)
    const prevYear = sortedYears[sortedYears.length - 2]
    const maxYear = sortedYears[sortedYears.length - 1]*/

    const yearN  = endYear;
    const yearN1 = endYear - 1;

    const totalEvolution = totalCA_N.map((ca, index) => calculatePercentage(ca, totalCA_N_1[index]));
    const totalN = filteredMonths.reduce((sum, { month }) => sum + totalCA_N[month - 1], 0);
    const totalN1 = filteredMonths.reduce((sum, { month }) => sum + totalCA_N_1[month - 1], 0);
    const overallTotalEvolution = totalN1 === 0 ? 0 : (((totalN - totalN1) / totalN1) * 100).toFixed(2);

    const calculateTotalCA_N = (yearData) => {
        if (!yearData) return 0;
    
        return Object.keys(yearData).reduce((total, month) => {
            if (yearData[month] && yearData[month].ca) {
                return total + parseFloat(yearData[month].ca);
            } else {
                return total;
            }
        }, 0);
    };
    const chartData = {
        labels: months,  // les mois de l'année
        datasets: [
            {
                label: `Chiffre d'affaires N (${endYear})`,
                data: totalCA_N,  // valeurs pour l'année N
                fill: false,
                borderColor: 'rgb(148, 206, 247)',
                backgroundColor: 'rgb(148, 206, 247)',
                tension: 0.1
            },
            {
                label: `Chiffre d'affaires N-1 (${endYear - 1})`,
                data: totalCA_N_1,  // valeurs pour l'année N-1
                fill: false,
                borderColor: 'rgb(241, 110, 110)',
                backgroundColor: 'rgb(241, 110, 110)',
                tension: 0.1
            }
        ]
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Comparaison du Chiffre d\'Affaires N et N-1'
            }
        }
    };



    return (
        <div className='flex flex-row h-full w-full fixed'>
            <Sidebar />
            <div className="relative flex flex-col w-full h-full bg-bleuBlanc">
                <div className="h-[15%] w-full">
                    <Title title="Chiffre d'affaires" btn={false} handleExportExcel={clients} datee={endYear} onSubmitFilter={handleSubmit} />
                </div>
                <div className='mt-10 h-[80%] w-full px-1  overflow-y-auto scrollbar scrollbar-thin scrollbar-thumb-roseLogo scrollbar-track-grey100'>
                    <div className="flex h-[10%] w-full">
                        <div className=" h-full w-full">
                            <table className="max-h-[80%] min-h-[80%] w-[98%] border-collapse items-center bg-transparent border-collapse">
                                <thead className='h-[8%] max-h-1.5 text-blanc'>
                                    <tr className='bg-marineLogo h-full w-full'>
                                        <th className="align-middle text-blanc text-[70%] uppercase whitespace-nowrap w-[10%]">Clients</th>
                                        <th className="align-middle text-blanc text-[70%] uppercase whitespace-nowrap w-[10%]">
                                            <div>
                                                <div>Commercial</div>
                                                {userInfo.user.role === "Administrateur" || userInfo.user.role === "Responsable" ? (
                                                    <div><select
                                                        value={selectedCommercial}
                                                        onChange={(e) => setSelectedCommercial(e.target.value)}
                                                        className="ml-2 text-xs bg-marineLogo text-blanc border-none"
                                                    >
                                                        <option value="tous">Tous</option> 
                                                        {commerciaux.map((commercial) => ( 
                                                            <option key={commercial.idUser} value={commercial.idUser}>
                                                                {commercial.name} {commercial.firstName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    </div>
                                                ): null}
                                            </div>    
                                        </th>
                                        <th className="align-middle text-blanc text-[70%] uppercase whitespace-nowrap w-[10%]">
                                        <div className='Flex flex-col'>
                                                <div>Agence</div>
                                                <div>
                                                    <select
                                                        value={selectedAgence}
                                                        onChange={(e) => setSelectedAgence(e.target.value)}
                                                        className="ml-2 text-xs bg-marineLogo text-blanc border-none"
                                                    >
                                                        <option value="">aucune</option>
                                                        <option value="toutes">Toutes</option>
                                                        {agence.map((agenceItem) => (
                                                            <option key={agenceItem.code} value={agenceItem.code}>
                                                                {agenceItem.nom}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                </div>
                                        </th>
                                        <th className="align-middle text-blanc text-[70%] uppercase whitespace-nowrap w-[5%]"></th>
                                        {filteredMonths.map(({ month }, index) => (
                                            <th key={index} className="align-middle text-blanc text-[70%] uppercase whitespace-nowrap w-[5%]">
                                                {months[month - 1]}
                                            </th>
                                        ))}
                                        <th className="align-middle text-blanc text-[70%] uppercase whitespace-nowrap w-[5%]">Total</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div className="flex w-[99%] overflow-y-auto scrollbar scrollbar-thin scrollbar-thumb-roseLogo scrollbar-track-grey100 max-h-[90%] max-w-[99%]">
                        <table className="h-full w-full text-[70%] bg-blanc">
                            <tbody className='h-full w-full bg-blanc'>
                            {clients.map((client, clientIndex) => (
                                <React.Fragment key={clientIndex}>
                                    <tr className='border border-t'>
                                        <td className='uppercase text-marineLogo font-bold w-[10%]'>
                                            <Link to={`/profil/client/${client.codeClient}/${client.codeAgence}`}>
                                                <div className='overflow-x-auto scrollbar scrollbar-thin scrollbar-thumb-roseLogo scrollbar-track-grey100' style={{ width: '120px' }}>
                                                    {client.nomClient}
                                                </div>
                                            </Link>
                                        </td>
                                        <td className="p-1 w-[10%] text-center">{client.commercial}</td>
                                        <td className="p-1 w-[10%] text-center">{client.codeAgence}</td>
                                        <td className="p-1 w-[5%]"></td>
                                        <td className="p-1 text-center"></td>
                                    </tr>

                                    <tr>
                                        <td className='w-[10%]'></td>
                                        <td className='w-[10%]'></td>
                                        <td className='w-[10%]'></td>
                                        <td className='w-[5%]'>CA N</td>
                                        {filteredMonths.map(({ month }) => (
                                            <td key={`${clientIndex}-${month}-ca-n`} className="p-1 text-center w-[5%]">
                                                {client.annees?.[yearN]?.[month]?.ca !== undefined
                                                ? Number(client.annees[yearN][month].ca).toFixed(2)
                                                : '0.00'}
                                            </td>
                                        ))}
                                        <td className="p-1 text-center font-semibold w-[5%]">
                                            {calculateTotalCA_N(client.annees?.[yearN]).toFixed(2)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className='w-[10%]'></td>
                                        <td className='w-[10%]'></td>
                                        <td className='w-[10%]'></td>
                                        <td className='w-[5%]'>CA N-1</td>
                                        {filteredMonths.map(({ month }) => (
                                            <td key={`${clientIndex}-${month}-ca-n-1`} className="p-1 text-center w-[5%]">
                                                {client.annees?.[yearN1]?.[month]?.ca !== undefined
                                                ? Number(client.annees[yearN1][month].ca).toFixed(2)
                                                : '0.00'}
                                            </td>
                                        ))}
                                        <td className="p-1 text-center font-semibold w-[5%]">
                                            {calculateTotalCA_N(client.annees?.[yearN1]).toFixed(2)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className='w-[10%]'></td>
                                        <td className='w-[10%]'></td>
                                        <td className='w-[10%]'></td>
                                        <td className='w-[5%]'>Evol</td>
                                        {filteredMonths.map(({ month }) => (
                                            <td
                                                key={`${clientIndex}-${month}-evol`}
                                                className={`text-center p-0 w-[5%] font-semibold ${
                                                calculatePercentage(
                                                    client.annees?.[yearN]?.[month]?.ca ?? 0,
                                                    client.annees?.[yearN1]?.[month]?.ca ?? 0
                                                ) < 0 ? 'text-roseLogo' : 'text-vertLogo'
                                                }`}
                                            >
                                                {calculatePercentage(
                                                client.annees?.[yearN]?.[month]?.ca ?? 0,
                                                client.annees?.[yearN1]?.[month]?.ca ?? 0
                                                )}%
                                            </td>
                                        ))}
                                        <td
                                            className={`text-center p-0 font-semibold w-[5%] ${
                                                calculatePercentage(
                                                calculateTotalCA_N(client.annees?.[yearN]  ?? {}),
                                                calculateTotalCA_N(client.annees?.[yearN1] ?? {})
                                                ) < 0 ? 'text-roseLogo' : 'text-vertLogo'
                                            }`}
                                        >
                                            {calculatePercentage(
                                                calculateTotalCA_N(client.annees?.[yearN]  ?? {}),
                                                calculateTotalCA_N(client.annees?.[yearN1] ?? {})
                                            )}%
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))}
                                <>
                                    <tr className='border border-t'>
                                        <td className='uppercase font-bold w-[10%]'>Total</td>
                                        <td className="p-1 w-[10%]"></td>
                                        <td className="p-1 w-[10%]"></td>
                                        <td className="p-1 w-[5%]"></td>
                                        {filteredMonths.map(({ month }, index) => (
                                            <React.Fragment key={month}>
                                                <td className="text-center p-0 font-semibold w-[5%]">{totalCA_N[month - 1].toFixed(2)}</td>
                                            </React.Fragment>
                                        ))}
                                        <td className="text-center p-0 font-semibold w-[5%]">{
                                            filteredMonths.reduce((sum, { month }) => sum + totalCA_N[month - 1], 0).toFixed(2)
                                        }</td>
                                    </tr>
                                    <tr className='border border-t'>
                                        <td className='uppercase font-bold w-[10%]'>Total N-1</td>
                                        <td className="p-1 w-[10%]"></td>
                                        <td className="p-1 w-[10%]"></td>
                                        <td className="p-1 w-[5%]"></td>
                                        {filteredMonths.map(({ month }, index) => (
                                            <React.Fragment key={month}>
                                                <td className="text-center p-0 font-semibold w-[5%]">{totalCA_N_1[month - 1].toFixed(2)}</td>
                                            </React.Fragment>
                                        ))}
                                        <td className="text-center p-0 font-semibold w-[5%]">{filteredMonths.reduce((sum, { month }) => sum + totalCA_N_1[month - 1], 0).toFixed(2)}</td>
                                    </tr>
                                    <tr className='border border-t'>
                                        <td className='uppercase font-bold w-[10%]'>Évolution</td>
                                        <td className="p-1 w-[10%]"></td>
                                        <td className="p-1 w-[10%]"></td>
                                        <td className="p-1 w-[5%]"></td>
                                        {filteredMonths.map(({ month }, index) => (
                                            <React.Fragment key={month}>
                                                <td className={`text-center p-0 w-[5%] font-semibold ${totalEvolution[month - 1] < 0 ? 'text-roseLogo' : 'text-vertLogo'}`}>
                                                    {totalEvolution[month - 1]}%
                                                </td>
                                            </React.Fragment>
                                        ))}
                                        <td className={`text-center p-0 font-semibold w-[5%] ${overallTotalEvolution  < 0 ? 'text-roseLogo' : 'text-vertLogo'}`}>
                                            {overallTotalEvolution}%
                                        </td>
                                    </tr>
                                </>
                            </tbody>
                        </table>
                    </div>
                                     
                </div>
                <div className='w-[40%] h-[35%] mx-2 py-2'>
                        <GraphClients chartData={chartData} chartOptions={chartOptions} /> 
                </div>
            </div>
        </div>
    );
}
